class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close button, button.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.header) this.header.reveal();
    document.body.classList.add('modal-open');

    /* -- Target the Cart Button to get the pointer in the right spot -- */
    if (window.innerWidth >= 964) {
      const cart_button = document.querySelector('#cart-icon-bubble button');
      if (cart_button) {
        const cart_button_loc = cart_button.getBoundingClientRect();
        const cart_button_width = cart_button.offsetWidth;
        const cart_button_width_half = cart_button_width / 2;
        const horz_offset = window.innerWidth - cart_button_loc.right + cart_button_width_half;
        //this.notification.style.top = `calc(${cart_button_loc.bottom}px + 1rem)`; //Too much animation to trust this
        this.notification.style.right = `calc(${horz_offset}px - var(--pointer-right-offset-cart) - 0.5rem)`;
      }
    }

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    //this.notification.style.removeProperty('top');
    this.notification.style.removeProperty('right');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('modal-open');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-notification-button') {
        document.getElementById(section.id).querySelector('.shared-button__leading-label').innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      } else {
        if (section.id === 'cart-notification-product') {
          const keys = parsedState.items.map((item) => item.key);
          let itemDom = '';

          keys.forEach((key) => {
            itemDom += `
              <div class="cart-notification-product-item">
                ${this.getSectionInnerHTML(parsedState.sections[section.id], `[id="${section.selector}-${key}"]`)}
              </div>
            `;
          });

          document.getElementById(section.id).innerHTML = itemDom;
        } else {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
